// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","626":"component---src-pages-book-jsx"}[chunkId] || chunkId) + "-" + {"279":"b0aed62d43ec3295ab25","454":"17010c9df5775afbbcab","626":"3a442add13ed05d274ec"}[chunkId] + ".js";
};